import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { api } from "../../../api/client.ts";
import { keys } from "../../../api/queryKeys.ts";
import { useTenant } from "../../../contexts/TenantContext.tsx";
import { CURRENCIES } from "../../../utils/currencies.ts";

function CurrencyPage() {
  const { selectedTenantId, selectedTenant } = useTenant();
  const queryClient = useQueryClient();
  const [currency, setCurrency] = useState("NOK");

  useEffect(() => {
    if (selectedTenant) setCurrency(selectedTenant.currency);
  }, [selectedTenant]);

  const mutation = useMutation({
    mutationFn: (code: string) => api.updateTenantCurrency(selectedTenantId!, code),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.tenant.all });
      toast.success("Currency saved");
    },
  });

  return (
    <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
      <TextField
        select
        size="small"
        label="Currency"
        value={currency}
        onChange={(e) => setCurrency(e.target.value)}
        sx={{ minWidth: 140 }}
      >
        {CURRENCIES.map((code) => (
          <MenuItem key={code} value={code}>
            {code}
          </MenuItem>
        ))}
      </TextField>
      <Button
        variant="contained"
        onClick={() => mutation.mutate(currency)}
        disabled={currency === selectedTenant?.currency}
        loading={mutation.isPending}
      >
        Save
      </Button>
    </Box>
  );
}

export default CurrencyPage;
